const refs = {
  openMobMenuBtn: document.querySelector('.bg_menu-btn'),
  closeMobMenuBtn: document.querySelector('.mb__close'),
  mobMenuOverlay: document.querySelector('.mobile-overlay'),
  lenBtn: document.querySelector('.mb__lang-toggle'),
  lenMenu: document.getElementById('mb__lang-menu'),
  mbBtnOrder: document.querySelector('.mb .button'),
};

const {
  openMobMenuBtn,
  closeMobMenuBtn,
  mobMenuOverlay,
  lenBtn,
  lenMenu,
  mbBtnOrder,
} = refs;

function handlerClickCloseMobMenu() {
  if (mobMenuOverlay) {
    mobMenuOverlay.classList.remove('active');
  }
  document.removeEventListener('keydown', handleEscapePress);
}

function handlerClickOpenMobMenu() {
  if (mobMenuOverlay) {
    mobMenuOverlay.classList.add('active');
  }
  document.addEventListener('keydown', handleEscapePress);
}

function handleEscapePress(event) {
  if (event.key === 'Escape') {
    handlerClickCloseMobMenu();
  }
}

function handlerClickLenBtn() {
  if (lenMenu) {
    lenMenu.classList.add('active');
  }
}

function handlerClickBtnOrder() {
  if (mobMenuOverlay) {
    mobMenuOverlay.classList.remove('active');
  }
}

// Додаємо перевірки на існування елементів перед додаванням event listeners
if (mobMenuOverlay) {
  mobMenuOverlay.addEventListener('click', e => {
    const isClickInside = e.target.closest('.mb');
    if (!isClickInside) {
      handlerClickCloseMobMenu();
    }
  });
}

if (lenBtn) {
  lenBtn.addEventListener('click', handlerClickLenBtn);
}

if (openMobMenuBtn) {
  openMobMenuBtn.addEventListener('click', handlerClickOpenMobMenu);
}

if (closeMobMenuBtn) {
  closeMobMenuBtn.addEventListener('click', handlerClickCloseMobMenu);
}

if (mbBtnOrder) {
  mbBtnOrder.addEventListener('click', handlerClickBtnOrder);
}

document.addEventListener('click', function (e) {
  const isClickOnLenMenu = e.target.closest('#mb__lang-menu');
  const isClickOnLenBtn = e.target.closest('.mb__lang-toggle');

  if (!isClickOnLenMenu && !isClickOnLenBtn && lenMenu) {
    lenMenu.classList.remove('active');
  }
});

// Close mobile menu when any link inside the menu is clicked
// This ensures the overlay hides after navigating to anchors or pages
const mbAllLinks = document.querySelectorAll('.mb a');
if (mbAllLinks && mbAllLinks.length) {
  mbAllLinks.forEach(link => {
    link.addEventListener('click', () => {
      handlerClickCloseMobMenu();
    });
  });
}
